import { render, staticRenderFns } from "./VacancyCardNew.htm?vue&type=template&id=af591f80&scoped=true&"
import script from "./VacancyCardNew.ts?vue&type=script&lang=js&"
export * from "./VacancyCardNew.ts?vue&type=script&lang=js&"
import style0 from "./VacancyCardNew.scss?vue&type=style&index=0&id=af591f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af591f80",
  null
  
)

export default component.exports